export default "__VITE_ASSET__UOoeE$PM__"